/**
 * 宣传专区
 */

export const NewsList = [{
        prop: "id",
        label: "id",
        width: "150",
        format: "",
        order: false,
        isShow: false,
    },
    {
        prop: "title",
        label: "标题",
        width: "150",
        format: "",
        order: false,
        isShow: true,
    },
    {
        prop: "categoryName",
        label: "分类名称",
        width: "150",
        format: "",
        order: false,
        isShow: true,
    },
    {
        prop: "type",
        label: "类型",
        width: "150",
        format: "type",
        order: false,
        isShow: true,
    },
    {
        prop: "startTime",
        label: "开始时间",
        width: "150",
        format: "datetime",
        order: false,
        isShow: true,
    },
    {
        prop: "endTime",
        label: "结束时间",
        width: "150",
        format: "datetime",
        order: false,
        isShow: true,
    },
    {
        prop: "creatorId",
        label: "创建人",
        width: "150",
        format: "",
        order: false,
        isShow: false
    },
    {
        prop: "creationTime",
        label: "创建时间",
        width: "150",
        format: "datetime",
        order: false,
        isShow: true
    }

]